import { render, staticRenderFns } from "./more-info.vue?vue&type=template&id=9c4fc1be"
import script from "./more-info.vue?vue&type=script&lang=js"
export * from "./more-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c4fc1be')) {
      api.createRecord('9c4fc1be', component.options)
    } else {
      api.reload('9c4fc1be', component.options)
    }
    module.hot.accept("./more-info.vue?vue&type=template&id=9c4fc1be", function () {
      api.rerender('9c4fc1be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/account/more-info.vue"
export default component.exports